<template>
  <article v-if="currentView" class="ut-card-base ut-border-green-400
    ut-border-t-2 ut-mb-8 md:ut-mb-16 ut--mx-4 sm:ut-mx-auto">
    <transition-fade>
      <component v-bind:is="currentView"
        :prospect="prospect"
        :userid="userid"
        @update-view="updateView">
      </component>
    </transition-fade>
  </article>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import HaveYouContacted from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesHaveYouContacted.vue';
import DidYouAppraise from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesDidYouAppraise.vue';
import DidYouFollowUp from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesDidFollowUp.vue';
import FollowUpReminder from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesFollowUpReminder.vue';
import SetFollowUpReminder from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesSetFollowUpReminder.vue';
import ContactedCallOutcome from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesContactedCallOutcome.vue';
import ContactedCallOutcomeAlt from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesContactedCallOutcomeAlternative.vue';
import AppraisedCallOutcome from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesAppraisedCallOutcome.vue';
import BookAppraisalReminder from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesBookAppraisalReminder.vue';
import RemoveProspect from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesRemoveProspect.vue';
import ProspectRemoved from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesProspectRemoved.vue';
import ProspectListed from '@/components/Prospecting/ProspectStageQuestions/ProspectStageQuesProspectListed.vue';
import RateProspectQuality from '@/components/Prospecting/ProspectQualityQuestions/ProspectQualityQuesRating.vue';
import LowRatingReason from '@/components/Prospecting/ProspectQualityQuestions/ProspectQualityQuesLowRatingReason.vue';
import LowRatingReasonCustom from '@/components/Prospecting/ProspectQualityQuestions/ProspectQualityQuesLowRatingReasonCustom.vue';
import ProspectStageType from '@/Mapper/ProspectStageType';
import ProspectStatusType from '@/Mapper/ProspectStatusType';
import TransitionFade from '@/components/TransitionFade.vue';
import { ProspectReminderTypeId } from '@/Mapper/ProspectActivityActionType';

export default {
  name: 'ProspectStageQuestions',
  components: {
    haveYouContacted: HaveYouContacted,
    rateProspectQuality: RateProspectQuality,
    lowRatingReason: LowRatingReason,
    lowRatingReasonCustom: LowRatingReasonCustom,
    didYouAppraise: DidYouAppraise,
    didYouFollowUp: DidYouFollowUp,
    followUpReminder: FollowUpReminder,
    setFollowUpReminder: SetFollowUpReminder,
    contactedCallOutcome: ContactedCallOutcome,
    contactedCallOutcomeAlt: ContactedCallOutcomeAlt,
    appraisedCallOutcome: AppraisedCallOutcome,
    bookAppraisalReminder: BookAppraisalReminder,
    removeProspect: RemoveProspect,
    prospectRemoved: ProspectRemoved,
    prospectListed: ProspectListed,
    transitionFade: TransitionFade,
  },
  props: {
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      nextView: null,
      prevView: null,
    };
  },
  computed: {
    ...mapState({
      prospect: state => state.prospectStore.prospect,
      stages: state => state.prospectStore.stages,
      status: state => state.prospectStore.status,
      reminders: state => state.prospectStore.reminders,
    }),
    ...mapGetters('prospectStore', [
      'activteReminder',
    ]),
    currentView() {
      // If: Prospect has been removed - over rides any stage changes or nextView
      if (this.prospect.status.statusType.statusTypeId === ProspectStatusType.removed) {
        return 'prospectRemoved';
      }

      /* NextView: when no stage change is needed,
         these screens will not show when a user loads / reloads the page
         the users will go back to their lastest stage change or active reminder screen */
      if (this.nextView) {
        return this.nextView;
      }

      // Do we have an active reminder?
      if (this.activteReminder && this.reminders[0]) {
        // console.log('active reminder');
        switch (this.activteReminder.reminderType.reminderTypeId) {
          case ProspectReminderTypeId.bookedAppraisal:
            return 'didYouAppraise';
          case ProspectReminderTypeId.followUp:
            return 'didYouFollowUp';
          default:
            return null;
        }
      }

      // When we have had a stage change
      switch (this.prospect.stage.stageType.stageTypeId) {
        case ProspectStageType.attempted:
          return 'haveYouContacted';
        case ProspectStageType.contacted:
          return 'contactedCallOutcome';
        case ProspectStageType.appraised:
          return 'appraisedCallOutcome';
        case ProspectStageType.listed:
          return 'prospectListed';
        case ProspectStageType.followUp:
          return 'setFollowUpReminder';
        default:
          return null;
      }
    },
  },
  created() {},
  methods: {
    updateView(nextView, usePrevView) {
      // eslint-disable-next-line prefer-destructuring
      const prevView = this.prevView;
      this.prevView = this.currentView;

      console.log('updateView');

      console.log(nextView);

      if (usePrevView) {
        this.nextView = prevView;
      } else {
        this.nextView = nextView;
      }
    },
  },
};
</script>

<style scoped lang="scss">
article {
  max-width: none;
}
</style>
